"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogType = exports.LogLevel = exports.LogDataType = void 0;
/**
 * @Author: Alexander Silva Barbosa
 * @Date:   2022-09-30 10:21:56
 * @Last Modified by:   Alexander Silva Barbosa
 * @Last Modified time: 2022-09-30 10:24:01
 */

const LogLevel = exports.LogLevel = {
  DEBUG: 1,
  INFO: 2,
  WARNING: 3,
  ERROR: 4,
  CRITICAL: 5
};
const LogType = exports.LogType = {
  DEVELOP: 0,
  INTERNAL: 1,
  USER: 2,
  EVENT: 3,
  HTTP_REQUEST: 4
};
const LogDataType = exports.LogDataType = {
  INPUT: 0,
  OUTPUT: 1,
  USER_INPUT: 2,
  USER_OUTPUT: 3,
  INTERNAL: 4
};